import i18n from 'modules/core/lib/i18n'

export const statusFilterOptions = () => [
  {
    label: i18n.t('trainings.my_training.all_courses_table.completed'),
    value: 'completed',
  },
  {
    label: i18n.t('trainings.my_training.all_courses_table.absent'),
    value: 'missing',
  },
  {
    label: i18n.t('trainings.my_training.all_courses_table.not_started'),
    value: 'notstarted',
  },
  {
    label: i18n.t('trainings.my_training.all_courses_table.partially_completed'),
    value: 'partiallycompleted',
  },
  {
    label: i18n.t('trainings.my_training.all_courses_table.started'),
    value: 'started',
  },
]
